// Водитель, не завершивший регистрацию в приложении.
// Ошибки API про него (409 registration_required, 422 registration_incomplete, 409 driver_not_registered)
// показываем текстом сервера; здесь — только текст карточки, которую рисует сам клиент.

// Профиль водителя без записи водителя (GET /profiles/driver/:id отдаёт id: null)
export const DRIVER_NOT_REGISTERED_MESSAGE = 'Водитель не завершил регистрацию';
